import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import Toast from "../../components/Toast";
import { getLatestAppointmentDetails, getPatientInformation } from "../../core/services/api";
import "./Searchbar.scss";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";


const SearchBar = ({ componentParent, onPatientIdSelected, placeholder = "Search" }: any) => {
  const [patient, setPatient] = useState<any>([])
  const [noAppointmentsError, setNoAppointmentsError] = useState<any>(false)
  const [Options, setOptions] = useState<any>(false)
  const [searchText, setSearchText] = useState<any>()
  const [selectedOptionIndex, setSelectedOptionIndex] = useState(-1);
  const [searchTimeout, setSearchTimeout] = useState<any>(null);

  const history = useHistory()
  const userDetail = useSelector((state: any) => state?.user?.userDetail)

  const optionsRef = useRef<HTMLInputElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);

  const patientInfo = (searchParam: any) => {
    if (!searchParam) {
      setPatient((prev: any) => [])
      return
    }
    else if (searchParam != searchText) {
      getPatientInformation(searchParam, userDetail?.currentCenter?.centerId)
        .then((res: any) => {
          const { data }: any = res
          setPatient(data)
        })
        .catch((err: any) => {
          console.error("err", err)
        })
    }
  }

  const clearInput = () => {
    setOptions(false)
    setSearchText('');
  };

  function redirectToOrSelect() {
    if (componentParent === 'Dashboard') {
    } else if (componentParent === 'ViewAllRequest') {
      onPatientIdSelected(patient.id);
    }
  }

  const redirectTo = (id: any) => {
    if (id) {
      getLatestAppointmentDetails(id)
        .then((res: any) => {
          setSearchText(''); // Clear the search text
          setSelectedOptionIndex(-1); // Reset selected option index
          history.push(`/patientDiagnosis/${id}?appointmentId=${res?.id}`);
        })
        .catch((err: any) => {
          setNoAppointmentsError(true);
          console.error(err?.message);
          setSearchText(''); // Clear the search text
          setSelectedOptionIndex(-1); // Reset selected option index
        });
    }
  };

  const handleEnterKey = () => {
    if (selectedOptionIndex >= 0) {
      const selectedOption = patient[selectedOptionIndex];
      if (componentParent === 'Dashboard') {
        redirectTo(selectedOption.id);
      } else if (componentParent === 'ViewAllRequest') {
        setSearchText(selectedOption?.mocId);
        onPatientIdSelected(patient);
        setOptions(false);
      }
    } else if (componentParent === 'Dashboard') {
      redirectTo(patient[0]?.id);
    } else if (componentParent === 'ViewAllRequest') {
      setSearchText(patient[0]?.mocId);
      onPatientIdSelected(patient[0]);
      setOptions(false);
    }
    if (componentParent === 'Dashboard') {
      clearInput();
    }
  };

  function onSearchClick(e: any) {
    if (searchText) {
      getPatientInformation(searchText, userDetail?.currentCenter?.centerId)
        .then((res: any) => {
          const { patients }: any = res
          if (patients?.length >= 1) {
            const selectedOption = patients[0];
            setOptions(false);
            setSelectedOptionIndex(-1);
            setSearchText("");
            patientInfo(selectedOption.name);
            if (componentParent === 'Dashboard') {
              redirectTo(selectedOption.id);
            } else if (componentParent === 'ViewAllRequest') {
              // Pass the entire patient object to onPatientIdSelected
              onPatientIdSelected(selectedOption);
            }
          }
        })
        .catch((err: any) => {
          console.error("err", err)
        })
    }

  }

  const handleClickOutside = (event: any) => {
    const inputElement: any = document.getElementsByTagName("input")?.[0]
    const dropdownElement: any = document.getElementsByClassName("options_suggestion")?.[0]
    if (!inputElement?.contains(event?.target) && !dropdownElement?.contains(event.target)) {
      if (
        inputRef?.current &&
        !inputRef?.current?.contains(event.target) &&
        optionsRef?.current &&
        !optionsRef?.current?.contains(event.target)
      ) {
        setSelectedOptionIndex(-1);
        setOptions(false);
      }
      else {
        setSelectedOptionIndex(-1)
        if (componentParent === "ViewAllRequest") {
          setOptions(false);
        }
        else {
          setOptions(false);
          setSearchText('');
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener('click', handleClickOutside);
    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (searchText) {
      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }
      const timeoutId = setTimeout(() => {
        if (searchText === searchText?.trim()) {
          getPatientInformation(searchText?.trim(), userDetail?.currentCenter?.centerId)
            .then((res: any) => {
              const { data }: any = res;
              setPatient(data);
            })
            .catch((err: any) => {
              console.error("err", err);
            });
        }
      }, 500);
      setSearchTimeout(timeoutId);
      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [searchText, userDetail?.currentCenter?.centerId]);

  useEffect(() => {
    if (selectedOptionIndex >= 0 && optionsRef.current) {
      const optionElement = optionsRef.current.childNodes[selectedOptionIndex] as HTMLElement;

      // Calculate the top and bottom positions of the option element
      const optionTop = optionElement.offsetTop;
      const optionBottom = optionTop + optionElement.offsetHeight;

      // Calculate the top and bottom positions of the visible area within the container
      const containerTop = optionsRef.current.scrollTop;
      const containerBottom = containerTop + optionsRef.current.clientHeight;

      // Scroll the container if the option is not fully visible
      if (optionBottom > containerBottom) {
        optionsRef.current.scrollTop = optionBottom - optionsRef.current.clientHeight;
      } else if (optionTop < containerTop) {
        optionsRef.current.scrollTop = optionTop;
      }
    }
  }, [selectedOptionIndex]);

  return (
    <div className="input-field-container">
      {
        noAppointmentsError ? (
          <Toast
            textMessage={"No Appointment History Found"}
            type={"error"}
            onCloseText="Close"
            onClickText={null}
            onClose={() => {
              setNoAppointmentsError(false)
            }}
          ></Toast>
        ) : null
      }
      <div className="search-bar">
        <span className="prefix">
          <FontAwesomeIcon icon={faMagnifyingGlass} color="#8A8A8A" />
        </span>
        <input
          name="Search"
          value={searchText}
          onKeyDown={(event) => {
            if (event.key === 'Enter') {
              event.preventDefault();
              // Prevent form submission
              handleEnterKey();
              // Add the following line to remove focus from the input field
              (event.target as HTMLInputElement).blur();
            } else if (event.key === 'ArrowUp') {
              event.preventDefault();
              // Prevent cursor from moving to the beginning of the input
              setSelectedOptionIndex((prevIndex) =>
                prevIndex > 0 ? prevIndex - 1 : patient.length - 1
              );
            } else if (event.key === 'ArrowDown') {
              event.preventDefault();
              // Prevent cursor from moving to the end of the input
              setSelectedOptionIndex((prevIndex) =>
                prevIndex < patient.length - 1 ? prevIndex + 1 : 0
              );
            }
          }}
          onBlur={(event: any) => {
            if (selectedOptionIndex >= 0) {
              const selectedOption = patient[selectedOptionIndex];
              setSearchText(selectedOption?.mocId);
              patientInfo(selectedOption.name);
            } else {
              patientInfo(searchText);
            }
            if (selectedOptionIndex >= 0) {
              redirectToOrSelect();
              if (componentParent === 'ViewAllRequest') {
                // Pass the entire patient object to onPatientIdSelected
                onPatientIdSelected(patient[selectedOptionIndex]);
              }
            }
          }}
          onChange={(e: any) => {
            const trimedSearchText = e.target.value.trimStart();
            if (trimedSearchText !== searchText && userDetail?.currentRole) {
              setOptions(true);
              setSearchText(trimedSearchText);
              setSelectedOptionIndex(-1);
              setPatient([]);
            }
          }}
          placeholder={placeholder}
        />
      </div>

      {searchText && Options && (
        <div ref={optionsRef} className="options_suggestion">
          {
            (patient?.length > 0) ? (
              patient?.map((ele: any, index: number) => {
                const isSelected = index === selectedOptionIndex;
                return (
                  <div
                    key={ele?.id}
                    className={`names ${isSelected ? "selected" : ""}`}
                    onClick={() => {
                      setOptions(false);
                      setSelectedOptionIndex(-1); // Reset selected option index
                      if (componentParent === 'Dashboard') {
                        redirectTo(ele.id);
                        setSearchText("");
                      } else if (componentParent === 'ViewAllRequest') {
                        onPatientIdSelected(ele);
                        setSearchText(ele?.mocId);
                      }
                    }}
                  >
                    {ele?.isVIP ? ele?.mocId : ele?.name}
                  </div>
                );
              })
            ) : (
              <div className="no-results-message">
                No results found
              </div>
            )
          }
        </div>
      )}


      {/* <img
        alt="SearchIcon"
        src="../../assets/images/searchIcon.svg"
        style={{ width: "20px", height: "20px", position: "relative", right: "30px", cursor: "pointer" }}
        onClick={() => onSearchClick(null)}
      /> */}

    </div>


  )
}








export default SearchBar